import React from 'react';

import { UserProfile } from '@totem/types/user';

export interface IBMenuItem {
  key: string;
  title: string;
  label: string;
  description?: React.ReactNode;
  route?: string;
  icon?: React.ReactNode;
  children?: IBMenuItem[];
  content?: React.ReactNode;
  hasPermissions?: (userProfile: UserProfile) => boolean;
}

export const mainMenuDisplayOptions = ['Left', 'Top'];

export const themeOptions = ['light', 'dark', 'os'];
